import React, { Component } from 'react';
import { connect } from 'react-redux';
import Sticky from 'Components/Sticky';
import { Link } from 'react-router-dom';
import { ReactComponent as BackIcon } from 'Icons/back.svg';
import Heading from 'Components/Heading';
import Tabs from 'Components/Tabs';
import Holistics from "Pages/Settings/Holistics";
import ContractingShortMis from "Pages/Settings/ContractingShortMis";
import HolisticsMis from "Pages/Settings/HolisticsMis";
import Checkbox from 'Components/Checkbox';
import TransporterParticipation from "Pages/Settings/TransporterParticipation";
import { getUser } from "Utils/storage";

const TABS = [
    {value: 'Contracting MIS - Short', id: 1},
    {value: 'Contracting MIS', id: 2},
    {value: 'Depot Contracting MIS', id: 6 },
    {value: 'Active Contracting Report', id: 3},
    {value: 'Transporter Participation Report', id: 4},
    {value: 'Product Disposal Contract MIS', id: 5}
];

const RFQ_TYPES = [
    {name: 'FTL', value: 1},
    {name: 'Multi Mode', value: 2}
];

const MULTI_MODE_TABS = [
    { value: 'Multimode Contract MIS', id: 70 },
]

class MISReports extends Component{
    constructor(props){
        super(props);
        this.state={
            selectedTab: 1,
            selectedRFQ: 1,
            data: {
                
            }
        }
    }

    selectTab = (id) => {
        this.setState({ selectedTab: id});
    }

    onChangeRFQType = (type) => {
        this.setState({ selectedRFQ: type, selectedTab: type == 1 ? 1 : (MULTI_MODE_TABS[0] || {}).id });
    }

    render(){
        const { selectedTab, selectedRFQ } = this.state;
        const user = getUser();
        return(
            <Sticky>
                <div className="pl-20 pr-20 pt-20 pb-20">
                    <Link to="/seeker">
                        <BackIcon className="fill-theme curP mr-5 fBolder"/>
                        {'Back'}
                    </Link>
                    <Heading type="medium" text="MIS Reports" className="mt-10 tCenter" />
                    <div className="mt-10 ph-10 flex flex-center">
                        {(RFQ_TYPES || []).map((rfqType) => <Checkbox label={rfqType.name} checked = {rfqType.value == selectedRFQ} className="mr-20 fBold" onCheck={() => this.onChangeRFQType(rfqType.value)}/>)}
                    </div>
                    <div className="mt-10 ph-10">
                        <Tabs key={1} selectTab={(id) => this.selectTab(id)} activeTabId={selectedTab} tabs={(selectedRFQ == 1 ? TABS : MULTI_MODE_TABS)} isBold={false}/>
                    </div>
                    {selectedTab === 1 && <div className="mt-10">
                        <ContractingShortMis/>
                    </div>}
                    {selectedTab === 2 && <div className="mt-10">
                        <Holistics/>
                    </div>}
                    {selectedTab === 3 && <div className="mt-10">
                        <HolisticsMis id={18}/>
                    </div>} 
                    {selectedTab === 4 && <div className="mt-10">
                         <TransporterParticipation />
                    </div>}
                    {selectedTab === 5 && <div className="mt-10">
                        <HolisticsMis id={34}/>
                    </div>} 
                    {(selectedTab === 6 && (user.isDepotUser || user.isHOUser)) && <div className="mt-10">
                        <HolisticsMis id={44}/>
                    </div>} 
                    {
                        selectedRFQ === 2 && <div className="mt-10">
                        <HolisticsMis id={selectedTab}/>
                    </div>
                    }

                </div>
            </Sticky>
        )
    }
        
}

export default connect()(MISReports);